import React from "react";
const Loader = () => {
  return (
    <div className="w-screen h-screen bg-[#131313] flex flex-col justify-center items-center">
      <svg
        // width="915"
        // height="366"
        viewBox="0 0 415 366"
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="lg:w-[915px] lg:h-[366px] w-1/2 h-1/2"
        // className="border-2 border-red-300"
      >
        <defs>
          <radialGradient
            id="grad1"
            cx="50%"
            cy="50%"
            r="50%"
            fx="50%"
            fy="50%"
          >
            <stop offset="1%" style={{ stopColor: "#F89B29" }} />
            <stop offset="73%" style={{ stopColor: "#F32E35" }} />
          </radialGradient>
        </defs>
        <path
          className="animate-[pathanimations_0.5s_0s_ease-in-out_forwards]"
          d="M181.5 163.68C217.586 163.68 246.84 134.426 246.84 98.34C246.84 62.2537 217.586 33 181.5 33C145.414 33 116.16 62.2537 116.16 98.34C116.16 134.426 145.414 163.68 181.5 163.68Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_0.3s_ease-in-out_forwards]"
          d="M182.407 227.205C196.942 227.205 208.725 215.422 208.725 200.888C208.725 186.353 196.942 174.57 182.407 174.57C167.873 174.57 156.09 186.353 156.09 200.888C156.09 215.422 167.873 227.205 182.407 227.205Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_0.3s_ease-in-out_forwards]"
          d="M115.253 205.425C129.787 205.425 141.57 193.642 141.57 179.108C141.57 164.573 129.787 152.79 115.253 152.79C100.718 152.79 88.9351 164.573 88.9351 179.108C88.9351 193.642 100.718 205.425 115.253 205.425Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_0.3s_ease-in-out_forwards]"
          d="M247.747 205.425C262.282 205.425 274.065 193.642 274.065 179.108C274.065 164.573 262.282 152.79 247.747 152.79C233.213 152.79 221.43 164.573 221.43 179.108C221.43 193.642 233.213 205.425 247.747 205.425Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_0.4s_ease-in-out_forwards]"
          d="M181.5 281.655C192.527 281.655 201.465 272.716 201.465 261.69C201.465 250.664 192.527 241.725 181.5 241.725C170.474 241.725 161.535 250.664 161.535 261.69C161.535 272.716 170.474 281.655 181.5 281.655Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_0.6s_ease-in-out_forwards]"
          d="M72.6 239.91C83.6264 239.91 92.565 230.971 92.565 219.945C92.565 208.919 83.6264 199.98 72.6 199.98C61.5736 199.98 52.635 208.919 52.635 219.945C52.635 230.971 61.5736 239.91 72.6 239.91Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_0.6s_ease-in-out_forwards]"
          d="M288.585 239.91C299.611 239.91 308.55 230.971 308.55 219.945C308.55 208.919 299.611 199.98 288.585 199.98C277.559 199.98 268.62 208.919 268.62 219.945C268.62 230.971 277.559 239.91 288.585 239.91Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_0.5s_ease-in-out_forwards]"
          d="M180.593 327.03C189.113 327.03 196.02 320.123 196.02 311.603C196.02 303.082 189.113 296.175 180.593 296.175C172.072 296.175 165.165 303.082 165.165 311.603C165.165 320.123 172.072 327.03 180.593 327.03Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_0.9s_ease-in-out_forwards]"
          d="M37.2075 272.58C45.7279 272.58 52.635 265.673 52.635 257.153C52.635 248.632 45.7279 241.725 37.2075 241.725C28.6872 241.725 21.78 248.632 21.78 257.153C21.78 265.673 28.6872 272.58 37.2075 272.58Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_0.9s_ease-in-out_forwards]"
          d="M325.792 272.58C334.313 272.58 341.22 265.673 341.22 257.153C341.22 248.632 334.313 241.725 325.792 241.725C317.272 241.725 310.365 248.632 310.365 257.153C310.365 265.673 317.272 272.58 325.792 272.58Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_0.6s_ease-in-out_forwards]"
          d="M181.5 365.145C187.514 365.145 192.39 360.269 192.39 354.255C192.39 348.241 187.514 343.365 181.5 343.365C175.485 343.365 170.61 348.241 170.61 354.255C170.61 360.269 175.485 365.145 181.5 365.145Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_1.2s_ease-in-out_forwards]"
          d="M10.89 294.36C16.9044 294.36 21.78 289.484 21.78 283.47C21.78 277.456 16.9044 272.58 10.89 272.58C4.87562 272.58 0 277.456 0 283.47C0 289.484 4.87562 294.36 10.89 294.36Z"
          fill="#131313"
        />
        <path
          className="animate-[pathanimations_0.5s_1.2s_ease-in-out_forwards]"
          d="M352.11 294.36C358.124 294.36 363 289.484 363 283.47C363 277.456 358.124 272.58 352.11 272.58C346.096 272.58 341.22 277.456 341.22 283.47C341.22 289.484 346.096 294.36 352.11 294.36Z"
          fill="#131313"
        />
      </svg>
    </div>
  );
};

export default Loader;
